import { render, staticRenderFns } from "./ActivateEmail.vue?vue&type=template&id=3412f7b5&scoped=true&"
import script from "./ActivateEmail.vue?vue&type=script&lang=js&"
export * from "./ActivateEmail.vue?vue&type=script&lang=js&"
import style0 from "./ActivateEmail.vue?vue&type=style&index=0&id=3412f7b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3412f7b5",
  null
  
)

export default component.exports